export default {
  GroupEmailerIndicateCurrentDraftEditor: {
    updated() {
      const { currentDraftEditorHcpgId } = this.el.dataset;

      const editorClasses = ["editor"];

      if (currentDraftEditorHcpgId) {
        // 1. Replace tooltip with "editing" for the current draft editor
        // and "watching" for everyone else.
        // 2. Add grouping and editor classes to editor's avatar.
        this.el
          .querySelectorAll("span[id^=create-campaign-presence-user]")
          .forEach((el) => {
            if (el.id.endsWith(currentDraftEditorHcpgId)) {
              el.classList.add(...editorClasses);

              const tooltip = el.querySelector("div[data-tooltip-fui] p");
              tooltip.innerText = tooltip.innerText.replace(
                "watching",
                "editing",
              );
            } else {
              el.classList.remove(...editorClasses);

              const tooltip = el.querySelector("div[data-tooltip-fui] p");
              tooltip.innerText = tooltip.innerText.replace(
                "editing",
                "watching",
              );
            }
          });
      }
    },
  },
};
